<template>
  <div class="container">
    <!-- header -->
    <div class="common-header-wrap">
      <mt-header title="Evaluation order" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <!-- body -->
    <div class="body">
      <div class="order-comment-body" v-for="(item, index) in orderItem" v-if="orderItem.length > 0" >
        <div class="body-list">
          <div class="image"><img v-bind:src="item.goods_image_url" /></div>
          <div class="comment">
            <span>{{ item.goods_name }}</span>
            <span class="common-score-wrapper" @click="setStar(item.goods_id,index,$event)" ref="star"><i class="iconfont front" :style="{width:score[index]/5*100+'%'}"></i><i class="iconfont back"></i></span>
          </div>
        </div>

        <div class="comment_bt">
          Add video/picture
          <small>({{img_count[item.goods_id] ? img_count[item.goods_id] : 0}}/{{img_max}})</small>
        </div>

        <div class="user-avatar-wrapper type_video" v-if="video[item.goods_id]">
          <div class="user-avatar">
            <img src="../../../assets/image/video_bg.png">
            <span @click="dropVideo(item.goods_id)" class="del-btn iconfont">&#xe6d8;</span>
          </div>
        </div>

        <div class="user-avatar-wrapper type_bg" v-for="(item2, index2) in img[item.goods_id]" v-if="img[item.goods_id].length > 0">
          <div class="user-avatar">
            <img :src="item2.goodsimage_full_url">
            <span @click="dropImage(item.goods_id, index2)" class="del-btn iconfont">&#xe6d8;</span>
          </div>
        </div>

        <div class="user-avatar-wrapper" v-if="img_count[item.goods_id] < img_max && video[item.goods_id] == ''">
          <div class="user-avatar video_btn">
            <div class="images_tips" v-if="images_tips">Within 15 seconds</div>
            <div class="center-text">Add video</div>
            <input ref="file" type="file" accept="video/mp4" @change="uploadInformVideo(item.goods_id, $event)">
          </div>
        </div>

        <div class="user-avatar-wrapper" v-if="img_count[item.goods_id] < img_max">
          <div class="user-avatar">
            <div class="center-text">Add picture</div>
            <input ref="file" type="file" accept="image/*" @change="uploadInformPic(item.goods_id, $event)">
          </div>
        </div>

        <div class="enter">
          <textarea placeholder="Please enter a comment" v-model="result.goods[item.goods_id].comment" ></textarea>
        </div>
      </div>

      <div v-if="!store_info.is_platform_store" class="store-evaluate">
        <div class="title">Store evaluation</div>
        <div class="comment">
          <span>Description</span>
          <span class="common-score-wrapper" @click="setStoreStar(0,$event)" ref="star"><i class="iconfont front" :style="{width:store_desccredit/5*100+'%'}"></i><i class="iconfont back"></i></span>
        </div>
        <div class="comment">
          <span>Service</span>
          <span class="common-score-wrapper" @click="setStoreStar(1,$event)" ref="star"><i class="iconfont front" :style="{width:store_servicecredit/5*100+'%'}"></i><i class="iconfont back"></i></span>
        </div>
        <div class="comment">
          <span>Delivery</span>
          <span class="common-score-wrapper" @click="setStoreStar(2,$event)" ref="star"><i class="iconfont front" :style="{width:store_deliverycredit/5*100+'%'}"></i><i class="iconfont back"></i></span>
        </div>
      </div>
    </div>

    <mt-button type="primary" @click='submit' class="ds-button-large">Submit</mt-button>

  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { Indicator, Toast } from 'mint-ui'
import { getOrderEvaluateInfo, saveOrderEvaluate, uploadInfoFile, uploadInfoVideo } from '../../../api/memberOrder'

export default {
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      store_info: {},
      orderItem: {},
      result: { goods: {} },
      score: [],
      store_desccredit: 5,
      store_servicecredit: 5,
      store_deliverycredit: 5,
      image: ['', '', ''],
      file_value: ['', '', ''],
      evaluate_pic: [],
      appeal_pic: [],
      length: [],
      showimage: '',
      isshow: false,
      images_tips: true,
      img: [],
      video: [],
      img_max: 9,
      img_count: []
    }
  },
  components: {
    VueCropper
  },
  created () {
    if (this.$route.params.order_id) {
      getOrderEvaluateInfo(this.$route.params.order_id).then(res => {
        this.orderItem = res.result.order_goods
        this.store_info = res.result.store_info
        this.img = res.result.img
        this.video = res.result.video
        for (var i in this.orderItem) {
          this.result.goods[this.orderItem[i].goods_id] = { comment: '', score: 5 }
          this.score[i] = 5
          if (this.img[this.orderItem[i].goods_id]) {
            this.length[i] = this.img[this.orderItem[i].goods_id].length
          } else {
            this.length[i] = 1
          }

          this.img_count[this.orderItem[i].goods_id] = 0
        }

        let that = this

        setTimeout(function () {
          that.images_tips = false
        }, 3000)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage (index1, index2) {
      let that = this

      var temp = that.img[index1]
      temp.splice(index2, 1)
      that.img[index1] = temp

      let img_count = that.img_count[index1]
      if (img_count == undefined || img_count == '') {
        img_count = 0
      }
      img_count -= 1
      if (img_count < 0) {
        img_count = 0
      }
      that.img_count[index1] = img_count

      that.$forceUpdate()
    },
    dropVideo (index1) {
      let that = this

      that.video[index1] = ''

      let img_count = that.img_count[index1]
      if (img_count == undefined || img_count == '') {
        img_count = 0
      }
      img_count -= 1
      if (img_count < 0) {
        img_count = 0
      }
      that.img_count[index1] = img_count

      that.$forceUpdate()
    },
    submit () {
      this.result['store_desccredit'] = this.store_desccredit
      this.result['store_servicecredit'] = this.store_servicecredit
      this.result['store_deliverycredit'] = this.store_deliverycredit

      console.log(this.result)

      saveOrderEvaluate(this.$route.params.order_id, this.result).then(res => {
        this.$router.push({ name: 'MemberOrderList', query: { state: 'state_noeval' } })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    setStoreStar (type, event) {
      let starWidth = this.$refs.star[0].offsetWidth
      let score = Math.ceil(event.offsetX / starWidth * 5)
      switch (type) {
        case 0:
          this.store_desccredit = score
          break
        case 1:
          this.store_servicecredit = score
          break
        case 2:
          this.store_deliverycredit = score
          break
      }
    },
    setStar (goods_id, index, event) {
      let starWidth = this.$refs.star[0].offsetWidth
      let score = Math.ceil(event.offsetX / starWidth * 5)
      this.result.goods[goods_id].score = score
      this.score.splice(index, 1, score)
    },
    uploadInformPic (index1) {
      let that = this
      let file = event.target.files[0]

      let formdata = new FormData()
      formdata.append('evaluate_pic', file)
      Indicator.open()
      uploadInfoFile(formdata).then(res => {
        if (!that.img[index1]) {
          that.img[index1] = []
        }

        var temp = that.img[index1]

        let temp2 = {
          goodsimage_full_url: '',
          goodsimage_url: ''
        }
        temp2['goodsimage_full_url'] = res.result.url
        temp2['goodsimage_url'] = res.result.path

        temp.push(temp2)

        that.img[index1] = temp

        that.$forceUpdate()
        that.result.goods[index1].img = temp

        let img_count = that.img_count[index1]
        if (img_count == undefined || img_count == '') {
          img_count = 0
        }
        img_count += 1
        that.img_count[index1] = img_count

        Indicator.close()
      }).catch(function (error) {
        Toast(error.message)
        Indicator.close()
      })
    },
    uploadInformVideo (index1) {
      let that = this
      let file = event.target.files[0]

      let formdata = new FormData()
      formdata.append('evaluate_video', file)
      Indicator.open()
      uploadInfoVideo(formdata).then(res => {
        if (!that.video[index1]) {
          that.video[index1] = ''
        }

        let temp2 = {
          goodsvideo_full_url: '',
          goodsvideo_url: ''
        }
        temp2['goodsvideo_full_url'] = res.result.url
        temp2['goodsvideo_url'] = res.result.path

        that.video[index1] = temp2

        that.$forceUpdate()
        that.result.goods[index1].video = temp2

        let img_count = that.img_count[index1]
        if (img_count == undefined || img_count == '') {
          img_count = 0
        }
        img_count += 1
        that.img_count[index1] = img_count

        Indicator.close()
      }).catch(function (error) {
        Toast(error.message)
        Indicator.close()
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.common-score-wrapper .back{display: block}
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  .body {
    top: 2.2rem;
    width: 100%;
    .store-evaluate{
      padding:.5rem;background: #fff;font-size:.7rem;
      .title{
        line-height: 2rem;
        border-top:1px solid #e1e1e1;
        font-size:.8rem;
      }
      .common-score-wrapper{
        margin-left:.5rem;
      }
    }
    .order-comment-body {
      background: rgba(255, 255, 255, 1);
      padding: 10px;
      .body-list {
        display: flex;
        justify-content: left;
        align-content: center;
        align-items: center;
        padding-bottom: 0.75rem;
        border-bottom: 1px solid #e8eaed;
      }
      .image {
        width: 3.75rem;
        height: 3.75rem;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .comment {
        flex-basis: 100%;
        padding-left: 0.75rem;
        span {
          font-size: 0.8rem;
          color: #7c7f88;
          text-align: left;
          display: block;
        }
        ul {
          display: flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          margin-top: 1.2rem;
          li {
            img {
              width: 0.95rem;
              height: 0.95rem;
              flex-shrink: 0;
            }
            label {
              font-size: 0.7rem;
              color: rgba(78, 84, 93, 1);
              font-weight: normal;
            }
          }
        }
      }
      .enter {
        padding-top: 0.75rem;
        textarea {
          width: 100%;
          height: 6rem;
          background: rgba(247, 249, 250, 1);
          border: 1px solid #f7f9fa;
          box-sizing: border-box;
          padding: 0.5rem 0 0 0.5rem;
          font-size: 0.7rem;
          -webkit-appearance: none;
          outline: none;
        }
      }
    }
  }
}
.user-avatar-wrapper{
  display: inline-block;
  vertical-align: top;
  margin-right: .5rem;
  margin-bottom:.5rem;
  background-color: #f7f7f7;
}
.user-avatar-wrapper .del-btn{
  position:absolute;
  bottom:.2rem;
  right:.2rem;
  background: rgba(255,255,255,1);
}
.user-avatar {
  display: block;
  position: relative;
  width: 75px;
  height: 75px;
  margin: 0 auto;
  text-align: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAoBAMAAABzztUZAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTJmZmZqamqqqqpmZmZ2dnZmZmff395mZmd3d3aioqMLCwp6entDQ0Onp6VYsth4AAAAHdFJOUwDfewxJKqi69Xt5AAAA7UlEQVQoz2NggAC2DghIYEAFGlDxJjRxCah4I6owawcMBKCIM8HFFVDEGeHiAlARxw5sQARuISpoZOjADhDiq+eVv9wFYSprIMRXloPALDDbwAIu3lsOATdQ1fdML6/cdWY1kDyBYn5neeUKINU1vXwGivj18h1guru8Flm8q7waas/28hVI4p0w7XAWRHw5VBVIZxWS+PZKuPemVyOJT6+Gi0OVQMSfV8HFl9chiZfXwMWPlxMhjsscXPYiufN6NRH+whUOuMINVzjjjBdgPNZii8eOs8jxjpx+kNMJrnSFIo4rHRIpjiud48gXAEIjvCuYiivNAAAAAElFTkSuQmCC);
  background-size: 23px auto;
  background-repeat: no-repeat;
  background-position: center 16px;
  img {
    width: 100%;
    height: 100%
  }
  input {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    opacity: 0
  }
  .center-text{
    padding-top:42px;
    font-size:12px;
    color: #999;
  }
  .images_tips{
    position: absolute;
    z-index: 3;
    pointer-events: none;
    background-color: rgba(0,0,0,.7);
    padding: 0 8px;
    white-space: nowrap;
    height: 22px;
    border-radius: 22px;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
    top: 0;
    left: 60%;
    -webkit-transform: translate(-50%,-90%);
    transform: translate(-50%,-90%);
  }
  .images_tips::after {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 50%;
    -webkit-transform: translateX(-54%);
    transform: translateX(-54%);
    width: 0;
    height: 0;
    border: 3px solid rgba(0,0,0,.7);
    border-top-color: transparent;
    border-left-color: transparent;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
.user-avatar.video_btn{
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAgBAMAAACfnVd0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURUdwTJmZmZ2dnZmZmZmZmZmZmZmZmXYKEUsAAAAGdFJOUwDhGZxJa1nR/OMAAABbSURBVCjPY3BMQwUiDBAghiaeCBJkUmBIQwcgcbNUrOKKQF1YxFlBJKY4kxl2cbALMcWZ07CLi+EQTxsVp6o4rnDGFS+44hFnvONKJzjTFTgdYk23DAoMONI5AEzQDRaSphRlAAAAAElFTkSuQmCC);
  background-position: center 20px;
}
.type_video .user-avatar::before{
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  background: url(../../../assets/image/icons_play.png) no-repeat;
  background-size: 100%;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.mint-cell:after{
  background-color: transparent;
}
.comment_bt{
  font-size: 14px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
}
.comment_bt small {
  color: #999;
  margin-left: 4px;
}
</style>
